module.exports = __webpack_public_path__ + "img/satan_wolf.8b710892.jpg";